






















  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
  import { Cart } from '@one/types/dist/orderpath/app'
  @Component
  export default class OneCartModalRename extends Vue {
    cartName: string = ''

    @Prop({
      type: Boolean,
      required: true,
    })
    value!: boolean;

    @Prop({
      type: Object,
      required: true,
    })
    currentCart!: Cart.Responses.BasicCartInfo;

    @Prop({
      type: Boolean,
      required: true,
    })
    progress!: boolean;

    @Prop({
      type: Number,
      required: false,
      default: 17,
    })
    max!: number;

    get isValid() {
      return this.cartName.trim().length < this.max
    }

    @Watch('value')
    onVisibilityChange() {
      this.cartName = ''
    }

    onRename() {
      this.$emit('rename', this.cartName.trim())
    }
  }
